import ElementPropertiesManager from 'assets/core/js/module/element-properties-manager'
import { PartialsEvents } from 'assets/core/js/module/partials-manager'
import accommodationCards from 'assets/themes/campings/js/page/product/accommodation-cards'
import type { SidePanelType } from '@ui/SidePanel/component'
import type { PartialEventDetail } from 'assets/core/js/module/partials-manager'

export default (): void => {
  handleShowMoreAccommodations()
  handlePartialUpdate()
}

export function toggleAccommodations(target: string): void {
  const el = document.querySelector(`#${target}.results__list-wrapper`)

  if (!el) {
    return
  }

  const hiddenEls = el?.querySelectorAll<HTMLElement>('.result__card-wrapper[data-visible]')

  hiddenEls?.forEach((el) => {
    if (el.getAttribute('data-visible') === 'true') {
      el.setAttribute('data-visible', 'false')
    } else {
      el.setAttribute('data-visible', 'true')
    }
  })

  const buttonEl = document.querySelector<HTMLButtonElement>(`button[data-additional-accommodations="${target}"]`)

  if (!buttonEl) {
    return
  }

  buttonEl.querySelectorAll('span').forEach((link) => {
    link.toggleAttribute('hidden')
  })
}

function handleShowMoreAccommodations(): void {
  const showAdditionalAccommodations = document.querySelectorAll<HTMLButtonElement>('.results__button-additional-accommodations')

  showAdditionalAccommodations.forEach((showAdditionalAccommodations) => {
    showAdditionalAccommodations.addEventListener('click', (e) => {
      const el = e.target as HTMLElement
      const target = el.getAttribute('data-additional-accommodations')

      target && toggleAccommodations(target)
    })
  })
}

function handlePartialUpdate(): void {
  const resultsEl = document.getElementById('results-list')

  if (!resultsEl) {
    return
  }

  const observer = new window.IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        accommodationCards()

        observer.unobserve(entry.target)
      }
    })
  })

  observer.observe(resultsEl)

  resultsEl.addEventListener(PartialsEvents.PRE_UPDATE, (e) => {
    const event = e as CustomEvent<PartialEventDetail>

    if (event.detail.partial && event.detail.partial !== resultsEl) {
      return
    }

    // remove all sidepanels as they are no longer needed
    document.querySelectorAll<HTMLElement>('.accommodation-side-panel').forEach((el) => {
      ElementPropertiesManager.getProperty<SidePanelType>(el, 'sidePanel')?.destroy()
    })
  })

  resultsEl.addEventListener(PartialsEvents.POST_UPDATE, (e) => {
    const event = e as CustomEvent<PartialEventDetail>

    if (event.detail.partial && event.detail.partial !== resultsEl) {
      return
    }

    handleShowMoreAccommodations()
  })
}
